module.exports = __webpack_public_path__ + "img/404.941be8f.svg";